<template>
  <div class="holder-table">
    <AlertErrorMsg
      ref="alert"
      :title="errorMessage"
      class="page-alert-error"
    />
    <TableHeader>
      <div class="contact">
        <div
          id="sort_calls_by_name"
          class="table-header-box"
          :class="{
            'sort-active': this.sortBy === 'name',
            'sorted-desc': this.order === DESC
          }"
          @click="sortedBy('name')"
        >
          <UserIcon />
          <span class="header-table-text">Contact</span>
          <arrowDown class="arrow" />
        </div>
      </div>

      <div class="date">
        <div
          id="sort_calls_by_date"
          class="table-header-box"
          :class="{
            'sort-active': this.sortBy === 'date',
            'sorted-desc': this.order === DESC
          }"
          @click="sortedBy('date')"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_16597_46958)">
              <path
                d="M3.5 0C3.63261 0 3.75979 0.0526784 3.85355 0.146447C3.94732 0.240215 4 0.367392 4 0.5V1H12V0.5C12 0.367392 12.0527 0.240215 12.1464 0.146447C12.2402 0.0526784 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526784 12.8536 0.146447C12.9473 0.240215 13 0.367392 13 0.5V1H14C14.5304 1 15.0391 1.21071 15.4142 1.58579C15.7893 1.96086 16 2.46957 16 3V14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V5H16V4H0V3C0 2.46957 0.210714 1.96086 0.585786 1.58579C0.960859 1.21071 1.46957 1 2 1H3V0.5C3 0.367392 3.05268 0.240215 3.14645 0.146447C3.24021 0.0526784 3.36739 0 3.5 0V0Z"
                fill="#D7DCE6"
              />
            </g>
            <defs>
              <clipPath id="clip0_16597_46958">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span class="header-table-text">Date</span>
          <arrowDown class="arrow" />
        </div>
      </div>

      <div class="start">
        <div
          class="table-header-box"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_16597_46958)">
              <path
                d="M3.5 0C3.63261 0 3.75979 0.0526784 3.85355 0.146447C3.94732 0.240215 4 0.367392 4 0.5V1H12V0.5C12 0.367392 12.0527 0.240215 12.1464 0.146447C12.2402 0.0526784 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526784 12.8536 0.146447C12.9473 0.240215 13 0.367392 13 0.5V1H14C14.5304 1 15.0391 1.21071 15.4142 1.58579C15.7893 1.96086 16 2.46957 16 3V14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V5H16V4H0V3C0 2.46957 0.210714 1.96086 0.585786 1.58579C0.960859 1.21071 1.46957 1 2 1H3V0.5C3 0.367392 3.05268 0.240215 3.14645 0.146447C3.24021 0.0526784 3.36739 0 3.5 0V0Z"
                fill="#D7DCE6"
              />
            </g>
            <defs>
              <clipPath id="clip0_16597_46958">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span class="header-table-text">Start time</span>
        </div>
      </div>

      <div class="end">
        <div
          id="sort_users_in_contacts_by_case_count"
          class="table-header-box"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_16597_46958)">
              <path
                d="M3.5 0C3.63261 0 3.75979 0.0526784 3.85355 0.146447C3.94732 0.240215 4 0.367392 4 0.5V1H12V0.5C12 0.367392 12.0527 0.240215 12.1464 0.146447C12.2402 0.0526784 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526784 12.8536 0.146447C12.9473 0.240215 13 0.367392 13 0.5V1H14C14.5304 1 15.0391 1.21071 15.4142 1.58579C15.7893 1.96086 16 2.46957 16 3V14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V5H16V4H0V3C0 2.46957 0.210714 1.96086 0.585786 1.58579C0.960859 1.21071 1.46957 1 2 1H3V0.5C3 0.367392 3.05268 0.240215 3.14645 0.146447C3.24021 0.0526784 3.36739 0 3.5 0V0Z"
                fill="#D7DCE6"
              />
            </g>
            <defs>
              <clipPath id="clip0_16597_46958">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span class="header-table-text">End Time</span>
        </div>
      </div>
      <div class="duration">
        <div
          id="sort_calls_by_duration"
          class="table-header-box"
          :class="{
            'sort-active': this.sortBy === 'duration',
            'sorted-desc': this.order === DESC
          }"
          @click="sortedBy('duration')"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_16597_31253)">
              <path
                d="M15.5643 11.7424L13.3315 9.50954C12.534 8.71209 11.1784 9.0311 10.8594 10.0678C10.6202 10.7855 9.82272 11.1842 9.10502 11.0247C7.51012 10.626 5.35702 8.5526 4.9583 6.87797C4.71906 6.16024 5.19753 5.36279 5.91523 5.12359C6.95191 4.80461 7.27089 3.44895 6.47345 2.65151L4.2406 0.418659C3.60264 -0.139553 2.64571 -0.139553 2.08749 0.418659L0.572347 1.93381C-0.9428 3.5287 0.731836 7.75516 4.47983 11.5032C8.22783 15.2511 12.4543 17.0056 14.0492 15.4106L15.5643 13.8955C16.1226 13.2575 16.1226 12.3006 15.5643 11.7424Z"
                fill="#D7DCE6"
              />
            </g>
            <defs>
              <clipPath id="clip0_16597_31253">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span class="header-table-text">Call duration</span>
          <arrowDown class="arrow" />
        </div>
      </div>
      <div class="status">
        <div
          id="sort_calls_by_status"
          class="table-header-box"
          :class="{
            'sort-active': this.sortBy === 'status',
            'sorted-desc': this.order === DESC
          }"
          @click="sortedBy('status')"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.4092 7.51562C9.04323 7.81951 8.45823 8.04354 8.00017 8.04354C7.54212 8.04354 6.95698 7.81993 6.59101 7.51604C5.97656 7.88201 5.6199 8.53424 5.57031 9.42313H10.43C10.3805 8.53424 10.0238 7.88174 9.4092 7.51562Z"
              fill="#DDE3E3"
            />
            <path
              d="M8.00052 6.85809C8.43594 6.86004 8.82955 6.59921 8.99761 6.19754C9.16552 5.79573 9.07469 5.3324 8.76747 5.02379C8.46025 4.71518 7.99719 4.62226 7.59469 4.78851C7.19233 4.95462 6.92969 5.34712 6.92969 5.78254C6.92899 6.37504 7.40802 6.85629 8.00052 6.85809Z"
              fill="#DDE3E3"
            />
            <path
              d="M6.5277 7.06224C6.61117 7.0203 6.71228 7.03752 6.77714 7.10474C7.0427 7.38113 7.60298 7.61446 8.00048 7.61446C8.39798 7.61446 8.95798 7.38071 9.22353 7.10432C9.28853 7.0371 9.38964 7.02016 9.47298 7.06238C10.303 7.47835 10.8003 8.31891 10.8574 9.42113H10.9514V2.87891H5.01367V9.42113H5.14326C5.20048 8.31891 5.6977 7.47821 6.5277 7.06224ZM8.00034 4.27974C8.60839 4.27793 9.15756 4.64266 9.39159 5.20391C9.62562 5.76502 9.49825 6.41196 9.06895 6.84252C8.63978 7.27321 7.99325 7.40252 7.43131 7.1703C6.86937 6.93807 6.50284 6.39002 6.50284 5.78196C6.50242 4.95405 7.17228 4.28196 8.00034 4.27974Z"
              fill="#DDE3E3"
            />
            <path
              d="M6.16548 1.21062H9.83493C9.95048 1.21062 10.0483 1.13812 10.0483 1.05062C10.0483 0.963125 9.95048 0.890625 9.83493 0.890625H6.16548C6.04993 0.890625 5.95215 0.963125 5.95215 1.05062C5.95215 1.13812 6.04993 1.21062 6.16548 1.21062Z"
              fill="#DDE3E3"
            />
            <path
              d="M12.4802 0H3.52024C3.24538 0 3.02246 0.222917 3.02246 0.497778V15.5022C3.02246 15.7771 3.24538 16 3.52024 16H12.4802C12.7551 16 12.978 15.7771 12.978 15.5022V0.497778C12.978 0.222917 12.7551 0 12.4802 0ZM6.16552 0.462222H9.83496C10.1877 0.462222 10.475 0.724583 10.475 1.04889C10.475 1.37319 10.1877 1.63556 9.83496 1.63556H6.16552C5.81274 1.63556 5.52552 1.37319 5.52552 1.04889C5.52552 0.724583 5.81274 0.462222 6.16552 0.462222ZM4.58691 2.80889C4.58691 2.6125 4.74607 2.45333 4.94246 2.45333H11.0225C11.2189 2.45333 11.378 2.6125 11.378 2.80889V9.49333C11.378 9.68972 11.2189 9.84889 11.0225 9.84889H4.94246C4.74607 9.84889 4.58691 9.68972 4.58691 9.49333V2.80889ZM4.90691 11.52C4.78913 11.52 4.69357 11.4244 4.69357 11.3067C4.69357 11.1889 4.78913 11.0933 4.90691 11.0933H11.058C11.1758 11.0933 11.2714 11.1889 11.2714 11.3067C11.2714 11.4244 11.1758 11.52 11.058 11.52H4.90691ZM10.738 12.7644C10.738 12.8822 10.6425 12.9778 10.5247 12.9778H5.44024C5.32246 12.9778 5.22691 12.8822 5.22691 12.7644C5.22691 12.6467 5.32246 12.5511 5.44024 12.5511H10.5247C10.6425 12.5511 10.738 12.6467 10.738 12.7644ZM11.5914 14.4H4.37357C4.25579 14.4 4.16024 14.3044 4.16024 14.1867C4.16024 14.0689 4.25579 13.9733 4.37357 13.9733H11.5914C11.7091 13.9733 11.8047 14.0689 11.8047 14.1867C11.8047 14.3044 11.7091 14.4 11.5914 14.4Z"
              fill="#D7DCE6"
            />
          </svg>
          <span class="header-table-text">Status</span>
          <arrowDown class="arrow" />
        </div>
      </div>
    </TableHeader>
    <div class="table-body">
      <div
        v-for="(item, index) in callLogsList"
        :key="index"
        class="table-row"
      >
        <div class="card">
          <div class="contact">
            <div class="holder-info">
              <span>{{ item.callerName }}</span>
              <p>{{ item.phoneNumber ? item.phoneNumber : "No phone number" }}</p>
            </div>
          </div>

          <div class="date">
            <div class="holder-info">
              <span class="info-name">{{ parseDate(item.callStartTime) }}</span>
            </div>
          </div>

          <div class="start">
            <div class="holder-info">
              <span>{{ reformatTime(item.callStartTime) }}</span>
            </div>
          </div>

          <div class="end">
            <div class="holder-info">
              <span>{{ reformatTime(item.callEndTime) }}</span>
            </div>
          </div>

          <div class="duration">
            <div class="holder-info">
              <span>{{ formatMillis(item.callDurationMillis) }}</span>
            </div>
          </div>

          <div class="status">
            <div
              class="holder-info"
              :style="{
                backgroundColor: item.callStatus === 'accepted'
                  ? '#00CA1424'
                  : item.callStatus === 'declined' || item.callStatus === 'rejected'
                    ? '#CA000024'
                    : '#5692B724'
              }"
            >
              <svg
                v-if="item.callStatus === 'outgoing'"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.14626 7.35366C9.09977 7.30722 9.06289 7.25207 9.03773 7.19138C9.01256 7.13068 8.99961 7.06561 8.99961 6.99991C8.99961 6.9342 9.01256 6.86913 9.03773 6.80843C9.06289 6.74774 9.09977 6.69259 9.14626 6.64615L11.2931 4.4999H10C9.8674 4.4999 9.74022 4.44723 9.64645 4.35346C9.55268 4.25969 9.50001 4.13251 9.50001 3.9999C9.50001 3.8673 9.55268 3.74012 9.64645 3.64635C9.74022 3.55258 9.8674 3.49991 10 3.49991H12.5C12.6326 3.49991 12.7598 3.55258 12.8536 3.64635C12.9473 3.74012 13 3.8673 13 3.9999V6.49991C13 6.63251 12.9473 6.75969 12.8536 6.85346C12.7598 6.94723 12.6326 6.99991 12.5 6.99991C12.3674 6.99991 12.2402 6.94723 12.1465 6.85346C12.0527 6.75969 12 6.63251 12 6.49991V5.20678L9.85376 7.35366C9.80732 7.40014 9.75218 7.43702 9.69148 7.46218C9.63078 7.48735 9.56571 7.5003 9.50001 7.5003C9.4343 7.5003 9.36923 7.48735 9.30854 7.46218C9.24784 7.43702 9.19269 7.40014 9.14626 7.35366ZM13.9925 11.9424C13.8811 12.7893 13.4651 13.5667 12.8224 14.1293C12.1797 14.692 11.3542 15.0014 10.5 14.9999C5.53751 14.9999 1.50001 10.9624 1.50001 5.99991C1.49847 5.14571 1.80794 4.32017 2.37059 3.67746C2.93324 3.03476 3.71061 2.61885 4.55751 2.5074C4.77159 2.48121 4.98841 2.52493 5.17561 2.63205C5.36281 2.73917 5.51037 2.90394 5.59626 3.10178L6.91626 6.04928V6.05678C6.98194 6.20831 7.00906 6.37375 6.99521 6.53833C6.98136 6.7029 6.92696 6.86148 6.83688 6.99991C6.82563 7.01678 6.81376 7.0324 6.80126 7.04803L5.50001 8.59053C5.96813 9.54178 6.96313 10.528 7.92688 10.9974L9.44813 9.70303C9.46307 9.69047 9.47872 9.67879 9.49501 9.66803C9.63316 9.57541 9.79231 9.51888 9.95793 9.50359C10.1236 9.48831 10.2904 9.51476 10.4431 9.58053L10.4513 9.58428L13.3956 10.9037C13.5939 10.9891 13.7592 11.1365 13.8668 11.3238C13.9744 11.511 14.0185 11.728 13.9925 11.9424ZM13 11.8174C13 11.8174 12.9956 11.8174 12.9931 11.8174L10.0556 10.5012L8.53376 11.7962C8.51899 11.8087 8.50355 11.8203 8.48751 11.8312C8.3436 11.9272 8.17726 11.9842 8.00472 11.9967C7.83218 12.0092 7.65936 11.9767 7.50313 11.9024C6.33251 11.3368 5.16563 10.1787 4.59938 9.02053C4.5244 8.86544 4.49075 8.69361 4.5017 8.52169C4.51265 8.34978 4.56783 8.1836 4.66188 8.03928C4.67248 8.02233 4.68439 8.00624 4.69751 7.99116L6.00001 6.44678L4.68751 3.50928C4.68726 3.50679 4.68726 3.50427 4.68751 3.50178C4.08141 3.58084 3.52493 3.87813 3.12226 4.33798C2.7196 4.79782 2.49837 5.38868 2.50001 5.99991C2.50232 8.12093 3.34592 10.1544 4.84571 11.6542C6.3455 13.154 8.37898 13.9976 10.5 13.9999C11.1109 14.002 11.7016 13.7815 12.1617 13.3798C12.6218 12.978 12.9198 12.4223 13 11.8168V11.8174Z"
                  fill="#373C44"
                />
              </svg>
              <svg
                v-else-if="item.callStatus === 'declined' || item.callStatus === 'rejected'"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.14626 6.64612L10.2931 5.49987L9.14626 4.35362C9.05244 4.2598 8.99973 4.13256 8.99973 3.99987C8.99973 3.86719 9.05243 3.73994 9.14626 3.64612C9.24008 3.5523 9.36732 3.4996 9.50001 3.4996C9.63269 3.4996 9.75994 3.5523 9.85376 3.64612L11 4.793L12.1463 3.64612C12.2401 3.5523 12.3673 3.4996 12.5 3.4996C12.6327 3.4996 12.7599 3.5523 12.8538 3.64612C12.9476 3.73994 13.0003 3.86719 13.0003 3.99987C13.0003 4.13256 12.9476 4.2598 12.8538 4.35362L11.7075 5.49987L12.8538 6.64612C12.9002 6.69258 12.9371 6.74773 12.9622 6.80843C12.9873 6.86912 13.0003 6.93418 13.0003 6.99987C13.0003 7.06557 12.9873 7.13063 12.9622 7.19132C12.9371 7.25202 12.9002 7.30717 12.8538 7.35362C12.8073 7.40008 12.7522 7.43693 12.6915 7.46207C12.6308 7.48721 12.5657 7.50015 12.5 7.50015C12.4343 7.50015 12.3693 7.48721 12.3086 7.46207C12.2479 7.43693 12.1927 7.40008 12.1463 7.35362L11 6.20675L9.85376 7.35362C9.75994 7.44744 9.63269 7.50015 9.50001 7.50015C9.36732 7.50015 9.24008 7.44744 9.14626 7.35362C9.05243 7.2598 8.99973 7.13256 8.99973 6.99987C8.99973 6.86719 9.05243 6.73994 9.14626 6.64612ZM13.9925 11.9424C13.8811 12.7893 13.4651 13.5666 12.8224 14.1293C12.1797 14.6919 11.3542 15.0014 10.5 14.9999C5.53751 14.9999 1.50001 10.9624 1.50001 5.99987C1.49847 5.14568 1.80794 4.32014 2.37059 3.67743C2.93324 3.03473 3.71061 2.61882 4.55751 2.50737C4.77166 2.48122 4.98854 2.52504 5.17575 2.63227C5.36296 2.73951 5.51047 2.90441 5.59626 3.10237L6.91626 6.04925V6.05675C6.98194 6.20828 7.00906 6.37372 6.99521 6.5383C6.98136 6.70287 6.92696 6.86145 6.83688 6.99987C6.82563 7.01675 6.81376 7.03237 6.80126 7.048L5.50001 8.5905C5.96813 9.54175 6.96313 10.528 7.92688 10.9974L9.44813 9.703C9.46307 9.69044 9.47872 9.67875 9.49501 9.668C9.63331 9.57575 9.79244 9.51944 9.95799 9.50416C10.1235 9.48888 10.2903 9.51512 10.4431 9.5805L10.4513 9.58425L13.3956 10.9036C13.5939 10.9891 13.7592 11.1365 13.8668 11.3237C13.9744 11.511 14.0185 11.728 13.9925 11.9424ZM13 11.8174C13 11.8174 12.9956 11.8174 12.9931 11.8174L10.0556 10.5017L8.53376 11.7961C8.51899 11.8086 8.50355 11.8203 8.48751 11.8311C8.3436 11.9271 8.17726 11.9842 8.00472 11.9966C7.83218 12.0091 7.65936 11.9767 7.50313 11.9024C6.33251 11.3367 5.16563 10.1786 4.59938 9.0205C4.5244 8.86541 4.49075 8.69358 4.5017 8.52166C4.51265 8.34974 4.56783 8.18357 4.66188 8.03925C4.67248 8.0223 4.68439 8.00621 4.69751 7.99112L6.00001 6.44675L4.68751 3.50925C4.68726 3.50675 4.68726 3.50424 4.68751 3.50175C4.08141 3.58081 3.52493 3.8781 3.12226 4.33795C2.7196 4.79779 2.49837 5.38865 2.50001 5.99987C2.50232 8.12089 3.34592 10.1544 4.84571 11.6542C6.3455 13.154 8.37898 13.9976 10.5 13.9999C11.1109 14.002 11.7016 13.7815 12.1617 13.3797C12.6218 12.9779 12.9198 12.4223 13 11.8167V11.8174Z"
                  fill="#373C44"
                />
              </svg>
              <svg
                v-else-if="item.callStatus === 'accepted'"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.00001 6.99928V4.49928C9.00001 4.36667 9.05268 4.23949 9.14645 4.14573C9.24022 4.05196 9.3674 3.99928 9.50001 3.99928C9.63262 3.99928 9.75979 4.05196 9.85356 4.14573C9.94733 4.23949 10 4.36667 10 4.49928V5.79241L12.1463 3.64553C12.2401 3.55171 12.3673 3.499 12.5 3.499C12.6327 3.499 12.7599 3.55171 12.8538 3.64553C12.9476 3.73935 13.0003 3.8666 13.0003 3.99928C13.0003 4.13196 12.9476 4.25921 12.8538 4.35303L10.7075 6.49928H12C12.1326 6.49928 12.2598 6.55196 12.3536 6.64573C12.4473 6.73949 12.5 6.86667 12.5 6.99928C12.5 7.13189 12.4473 7.25907 12.3536 7.35283C12.2598 7.4466 12.1326 7.49928 12 7.49928H9.50001C9.3674 7.49928 9.24022 7.4466 9.14645 7.35283C9.05268 7.25907 9.00001 7.13189 9.00001 6.99928ZM13.9925 11.9418C13.8811 12.7887 13.4652 13.566 12.8224 14.1287C12.1797 14.6913 11.3542 15.0008 10.5 14.9993C5.53751 14.9993 1.50001 10.9618 1.50001 5.99928C1.49836 5.14512 1.8078 4.31959 2.37048 3.67696C2.93317 3.03433 3.71061 2.61858 4.55751 2.5074C4.77159 2.48121 4.98841 2.52493 5.17561 2.63205C5.36281 2.73916 5.51037 2.90394 5.59626 3.10178L6.91626 6.04866V6.05616C6.98194 6.20769 7.00906 6.37313 6.99521 6.5377C6.98136 6.70228 6.92696 6.86086 6.83688 6.99928C6.82563 7.01615 6.81376 7.03178 6.80126 7.0474L5.50001 8.5899C5.96813 9.54115 6.96313 10.5274 7.92688 10.9968L9.44813 9.7024C9.46307 9.68985 9.47872 9.67816 9.49501 9.66741C9.63332 9.57516 9.79244 9.51885 9.95799 9.50357C10.1235 9.48829 10.2903 9.51453 10.4431 9.5799L10.4513 9.58366L13.3956 10.903C13.5939 10.9885 13.7592 11.1359 13.8668 11.3231C13.9744 11.5104 14.0185 11.7274 13.9925 11.9418ZM13 11.8168C13 11.8168 12.9956 11.8168 12.9931 11.8168L10.0556 10.5012L8.53376 11.7955C8.51915 11.8082 8.5037 11.8199 8.48751 11.8305C8.3436 11.9265 8.17726 11.9836 8.00472 11.9961C7.83219 12.0085 7.65936 11.9761 7.50313 11.9018C6.33251 11.3362 5.16563 10.178 4.59938 9.01991C4.5244 8.86481 4.49075 8.69298 4.5017 8.52107C4.51265 8.34915 4.56783 8.18298 4.66188 8.03865C4.67248 8.02171 4.68439 8.00562 4.69751 7.99053L6.00001 6.44616L4.68751 3.50866C4.68726 3.50616 4.68726 3.50365 4.68751 3.50115C4.08142 3.58022 3.52493 3.87751 3.12226 4.33735C2.7196 4.7972 2.49837 5.38806 2.50001 5.99928C2.50232 8.1203 3.34592 10.1538 4.84571 11.6536C6.3455 13.1534 8.37899 13.997 10.5 13.9993C11.1109 14.0014 11.7016 13.7809 12.1617 13.3791C12.6218 12.9773 12.9198 12.4217 13 11.8162V11.8168Z"
                  fill="#373C44"
                />
              </svg>
              <span>{{ capitalizeFirstLetter(item.callStatus) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserIcon from '@/components/icons/UserIcon.vue';
import TableHeader from '@/components/table/TableHeader.vue';
import AlertErrorMsg from '@/components/profile/AlertErrorMsg.vue';
import reformatDate from '@/mixins/reformatDate';
import reformatDateToTime from '@/mixins/reformatDateToTime';
import reformatMillis from '@/mixins/reformatMillis';
import capitalizeFirstLetter from '@/mixins/capitalizeFirstLetter';
import parseDate from '@/mixins/parseDate';
import ArrowDown from '@/components/icons/ArrowDown.vue';
import {ASC, DESC} from '@/constants/const';

export default {
  name: 'CallLogsList',
  components: {
    ArrowDown,
    AlertErrorMsg,
    UserIcon,
    TableHeader,
  },
  mixins: [reformatDate, reformatDateToTime, reformatMillis, capitalizeFirstLetter, parseDate],
  props: {
    callLogsList: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      DESC,
      ASC,
      sortBy: 'name',
      order: ASC,
      errorMessage: '',
    };
  },
  methods: {
    sortedBy(filterName) {
      this.order = filterName === this.sortBy && this.order === DESC ? ASC : DESC;
      this.sortBy = filterName;
      this.$emit('sortBy', {sortBy: this.sortBy, order: this.order});
    },
  }
};
</script>

<style lang="scss" scoped>

.table-header {
  max-height: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  padding: 26px 0 22px 32px;
}

.table-header svg {
  margin-right: 5px;
}

.table-header-box {
  cursor: default;
}

.table-header-box svg path {
  fill: var(--input-placeholder-value-color);
  transition: all 0.3s;
}

.table-header-box:hover svg:first-child path {
  //fill: var(--accent-color);
}

.contact {
  max-width: 21%;
  width: 100%;
}

.date {
  max-width: 10%;
  width: 100%;
}

.start {
  max-width: 13%;
  width: 100%;
}

.end {
  max-width: 12%;
  width: 100%;
}

.duration {
  max-width: 15%;
  width: 100%;
}

.status {
  max-width: 20%;
  width: 100%;
}

.table-body {
  margin: 5px 0 0;
}

.card {
  display: flex;
  align-items: center;
  padding: 15px 0 15px 32px;
  border-bottom: 1px solid var(--case-btn-border-color);
}

.holder-info {
  display: flex;
  align-items: center;
  color: var(--secondary-text-color);
  max-width: 100%;
  overflow: auto;
}

.holder-info span {
  font-size: 12px;
  font-weight: 500;
  line-height: 19px;
  text-align: left;
  color: var(--secondary-text-color);
  max-width: 100%;
  overflow: auto;
  white-space: normal;
  text-overflow: unset;
  scrollbar-color: var(--background-color) transparent;
  scrollbar-width: thin;
}

.arrow {
  transition: transform 0.3s;
}

.card .contact {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card .contact .holder-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 3px;
  word-break: break-word;
}

.card .contact .holder-info span {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  text-align: left;
  color: var(--gray-color);
}

.card .contact .holder-info p {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  color: var(--light-gray);
  margin: 0;
}

.card .status .holder-info {
  width: 100px;
  height: 25px;
  padding: 2px 8px;
  border-radius: 20px;
  background-color: #5692B724;
}

.card .status .holder-info svg {
  margin-right: 5px;
}

.table-header-box:hover .header-table-text {
  text-decoration: none;
}
</style>